<div class="balance-details d-flex align-items-center bg-primary">
  <span class="icons material-icons text-white"> loyalty </span>
  <p class="m-0 font-size-14 fw-bold text-white">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
</div>
